import { http } from './config'

export default {
  drawer: () => {
    return http.get('rule/drawer')
  },
  getRules: () => {
    return http.get('rule/')
  }

}
